import Glide from '@glidejs/glide';

const baseSettings = {
   type: 'carousel',
   perView: 1,
}

const typeSettings = {
   'jobs-preview': {
      peek: 40,
      gap: 0,
      perView: 3,
      breakpoints: {
         1280: {
            peek: 32,
            perView: 2,
         },
         768: {
            peek: 20,
            perView: 1,
         }
      }
   },
   'testimonials': {
      autoplay: 5000,
      animationDuration: 1000
   },
   'book-section': {
      autoplay: 5000,
      animationDuration: 1000
   },
};



const carousel = ({ el }) => {
   const settings = {
      ...baseSettings,
      ...typeSettings[el.dataset.carousel] || {}
   };
   return new Glide(el, settings).mount();
}

export default carousel;